import React from 'react';
import styles from './pageContainer.module.css';

const PageContainer = ({ children, className = '' ,style = {}}) => {
  return (
    <div className={styles.backgroundWrapper}>
      <div className={styles.fixedTopArea}>
        <div style={{ height: '100%' }} />
      </div>

      <div className={`${styles.scrollArea} ${className}`} style={style} 
      >{children}</div>
    </div>
  );
};

export default PageContainer;

